import { z } from 'zod';
import type {
  ListAvailableAttachmentsRequest,
  ListAvailableAttachmentsResponse,
} from './list-available-attachments.dto.js';
import { InboundReceiptAttachmentSummarySchema } from './inbound-receipts-shared.schema.js';
import {
  InboundReceiptSourceTypeSchema,
  OfficialComparisonReviewStatusSchema,
} from './inbound-receipts-types.js';
import { IsoDateTimeSchema } from '../shipments/shipments-types.js';

export const ListAvailableAttachmentsRequestSchema: z.ZodType<ListAvailableAttachmentsRequest> = z
  .object({
    companyId: z.uuid(),
    stationId: z.uuid(),
    materialId: z.uuid().optional(),
    sourceType: InboundReceiptSourceTypeSchema.optional(),
    fromConfirmedAt: IsoDateTimeSchema.optional(),
    toConfirmedAt: IsoDateTimeSchema.optional(),
    reviewStatuses: z.array(OfficialComparisonReviewStatusSchema).optional(),
  })
  .strict();

export const ListAvailableAttachmentsResponseSchema: z.ZodType<ListAvailableAttachmentsResponse> =
  z
    .object({
      items: z.array(InboundReceiptAttachmentSummarySchema),
    })
    .strict();
